import { Input } from 'antd';

import { useTimeInput } from '../hooks';

import type { InputProps } from 'antd';
import type { FC } from 'react';

interface TimeInputProps
  extends Omit<InputProps, 'value' | 'onChange' | 'maxLength'> {
  value?: string;
  onChange?(value: string): void;
}

// Поле ручного ввода времени ЧЧ:ММ вместо выпадающего списка слотов.
export const TimeInput: FC<TimeInputProps> = ({
  value,
  onChange,
  onBlur,
  placeholder = 'ЧЧ:ММ',
  ...props
}) => {
  const { handleChange, handleBlur } = useTimeInput({
    value,
    onChange,
    onBlur,
  });

  return (
    <Input
      {...props}
      value={value}
      placeholder={placeholder}
      inputMode="numeric"
      autoComplete="off"
      maxLength={5}
      onChange={handleChange}
      onBlur={handleBlur}
    />
  );
};
